module.exports = __webpack_public_path__ + "img/bolt-auto.50efcb12.svg";